export const SET = 'followUps/set'
export const CLEAR = 'followUps/clear'
export const SAVE = 'followUps/save'



// WEBPACK FOOTER //
// ./src/modules/deals/components/show/follow_ups/store/mutations_types.js